import type { FuturesBar } from "@/types/futuresChart"

const TIME_FORMAT = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
  timeZone: "America/New_York",
  timeZoneName: "short",
})

/** Marks a header price that comes from today's delayed intraday snapshot rather than a settled bar. */
export function ProvisionalBadge({ bar }: { bar: FuturesBar | undefined }) {
  if (!bar?.provisional) return null

  const asOf = bar.as_of ? new Date(bar.as_of) : null
  const time = asOf && !Number.isNaN(asOf.getTime()) ? TIME_FORMAT.format(asOf) : null
  const delay = bar.delay_minutes ? `${bar.delay_minutes} min delayed` : "Delayed"

  return (
    <span
      className="rounded border border-amber-500/40 bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-amber-300"
      title="Intraday price from the delayed snapshot. Replaced by the settled daily bar after the session closes."
    >
      {delay}
      {time ? ` · ${time}` : ""}
    </span>
  )
}
